<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>
        <span v-if="spec.relationTitle" class="secondary--text">
          {{ spec.relationTitle }}
        </span>
        <span>
          {{ spec.title }}
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu v-model="editTitle" :close-on-content-click="false" min-width="400" left offset-y>
        <template #activator="{ attrs, on }">
          <v-btn v-bind="attrs" v-on="on" text small>
            Ret navn
            <v-icon right> mdi-pencil-outline </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text>
            <v-text-field v-model="titleInput" autofocus label="Navn" clearable />
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="editTitle = false">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="saving" @click="update">
              {{ $t('common.save') }}
              <v-icon right> mdi-content-save-outline </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-menu v-model="deleteMenu" left bottom :close-on-content-click="false">
        <template #activator="{ attrs, on }">
          <v-btn v-bind="attrs" v-on="on" :disabled="$attrs.locked" text small>
            Slet
            <v-icon right> mdi-delete-outline </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title> Er du sikker? </v-card-title>
          <v-card-text class="warning--text">
            OBS! Alle aftaler forbundet til denne specifikation vil også blive slettet permanent.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="deleteMenu = false"> Nej, gå tilbage </v-btn>
            <v-btn :loading="deleting" color="error" @click="deleteSpecification">
              Ja, slet specifikationen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>
  </div>
</template>

<script>
import SpecificationMessages from './SpecificationMessages.vue';

export default {
  name: 'SpecificationToolbar',
  components: {
    SpecificationMessages
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    spec: {
      type: Object,
      required: true
    },
    specBaseRoute: {
      type: String
    }
  },
  data() {
    return {
      creating: false,
      deleting: false,
      deleteMenu: false,
      editTitle: false,
      saving: false,
      titleInput: this.spec.title
    }
  },
  computed: {
    messageCount() {
      return this.messages.filter(x => x.type === 'Message').length
    }
  },
  methods: {
    deleteSpecification: async function() {
      try {
        this.deleting = true;

        const response = await this.$api.delete(`specification/${this.$route.params.specId}`);

        if (!response.data.success) throw 'Error deleting specification';

        this.$notifier.showSuccess({ message: 'Specifikationen blev slettet' });
        this.deleteMenu = false;

        if (this.specBaseRoute) {
          this.$router.push(this.specBaseRoute)
        }
      } catch (error) {
        console.error(error);
        this.$notifier.showError({ message: 'Der skete en fejl. Specifikationen blev ikke slettet.' });
      } finally {
        this.deleting = false;
      }
    },

    update: async function() {
      const data = {
        title: this.titleInput,
        lockedOn: this.spec.lockedOn
      };

      try {
        this.saving = true;

        const response = await this.$api.patch(`specification/${this.$route.params.specId}`, data);

        if (!response.data.success) throw 'Error updating spec';

        this.$notifier.showSuccess({ message: 'Ændringerne blev gemt' });
        this.editTitle = false;
        this.$emit('update');
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
        throw error;
      } finally {
        this.saving = false;
      }
    },
  }
}
</script>